import {
    CORE_LOAD_ALL_CONTROL_REQUEST,
    CORE_LOAD_ALL_CONTROL_SUCCESS,

    CORE_UPDATE_DOUT_REQUEST,
    CORE_UPDATE_DOUT_SUCCESS,

    CORE_UPDATE_DALI_REQUEST,
    CORE_UPDATE_DALI_SUCCESS,

    CORE_UPDATE_DMX_REQUEST,
    CORE_UPDATE_DMX_SUCCESS,
} from '../../types'
import { testAllController } from 'Lib'
const initialState = []
export default {
    allAccessControl: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_CONTROL_REQUEST:
                return []
            case CORE_LOAD_ALL_CONTROL_SUCCESS:
                // return testAllController
                return action.payload

            default:
                return state
        }
    },
    iotResponse: (state = initialState, action) => {
        switch (action.type) {
            case CORE_UPDATE_DOUT_REQUEST:
                return { status: false, moduleName: "dout" }
            case CORE_UPDATE_DOUT_SUCCESS:
                return { status: action.payload, moduleName: "dout" }
            case CORE_UPDATE_DALI_REQUEST:
                return { status: false, moduleName: "dali" }
            case CORE_UPDATE_DALI_SUCCESS:
                return { status: action.payload, moduleName: "dali" }
            case CORE_UPDATE_DMX_REQUEST:
                return { status: false, moduleName: "dmx" }
            case CORE_UPDATE_DMX_SUCCESS:
                return { status: action.payload, moduleName: "dmx" }
            default:
                return state
        }
    },
    builgingList: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_CONTROL_REQUEST:
                return []
            case CORE_LOAD_ALL_CONTROL_SUCCESS:
                let data = action.payload,
                    buildingList = [],
                    options = []
                if (data && data.length > 0) {
                    data.forEach(element => {
                        let building = element.building
                        if (!building) building = { _id: "1", name: "No Building" }
                        const { _id, name } = building ? building : {}
                        let check = building && buildingList ? buildingList.findIndex(b => b._id === _id) : null
                        if (check === -1) {
                            buildingList.push({ _id: _id, name: name })
                        }
                    });
                }
                let filterBuilding = buildingList.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                return {
                    buildings: filterBuilding,
                    buildingOptions: options,
                }
            default:
                return []
        }
    },
    allIotModuleWithBuilding: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_CONTROL_REQUEST:
                return []
            case CORE_LOAD_ALL_CONTROL_SUCCESS:
                let data = action.payload,
                    groupByfloor = []
                if (data && data.length > 0) {
                    data.forEach(element => {
                        const { floor, roomName, roomId, roomEmail, status, building } = element
                        let groupIndex = groupByfloor.findIndex(g => g.floorId && floor && g.floorId === floor._id),
                            dataObj = { roomName: roomName, roomId: roomId, roomEmail: roomEmail, status: status }
                        if (groupIndex > -1) {
                            let item = groupByfloor[groupIndex],
                                data = item.data
                            groupByfloor[groupIndex] = ({
                                buildingName: building ? building.name : "No Building",
                                buildingId: building ? building._id : "1",
                                floorId: floor ? floor._id : "0",
                                floorName: floor ? floor.name : "No Floor",
                                data: data.concat([dataObj])
                            })
                        } else groupByfloor.push({
                            buildingName: building ? building.name : "No Building",
                            buildingId: building ? building._id : "1",
                            floorId: floor ? floor._id : "0",
                            floorName: floor ? floor.name : "No Floor",
                            data: [dataObj]
                        })
                    });
                }
                return groupByfloor

            default:
                return []
        }

    }
}


// WEBPACK FOOTER //
// ./src/features/allControl/reducers.js